import { getRequest } from '@/core';
import { orderChangelogs } from '@/requests';

export default async function getOrderChangelogRequest(id) {
	let url = orderChangelogs.getByIdPath(id);
	let response = await getRequest(url);
	return response;
}
